"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const number_with_commas_1 = require("../../util/number_with_commas");
const notification_wrapper_styles_1 = require("./notification_wrapper.styles");
const NotificationWrapper = ({ children, count }) => {
    const notification = count ? (0, number_with_commas_1.numberWithCommas)(count) : undefined;
    return ((0, jsx_runtime_1.jsxs)(notification_wrapper_styles_1.Container, { children: [count && ((0, jsx_runtime_1.jsx)(notification_wrapper_styles_1.Notification, Object.assign({ alignItems: "center", justifyContent: "center", p: 2, borderRadius: 1 }, { children: notification }))), children] }));
};
exports.default = NotificationWrapper;
//# sourceMappingURL=notification_wrapper.js.map